import { defaultDictionary } from './chunk-4DPTK2CR.js';
import { createContext, useContext } from 'react';

var AdminerContext = createContext(null);

// src/internal/i18n/useT.ts
var fallbackTranslator = (key, params) => {
  const raw = defaultDictionary[key] ?? key;
  if (!params) return raw;
  return raw.replace(
    /\{(\w+)\}/g,
    (_match, name) => params[name] !== void 0 ? String(params[name]) : `{${name}}`
  );
};
function useT() {
  const ctx = useContext(AdminerContext);
  return ctx ? ctx.t : fallbackTranslator;
}

export { AdminerContext, useT };
//# sourceMappingURL=chunk-3G2YSMCN.js.map
//# sourceMappingURL=chunk-3G2YSMCN.js.map